"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bew_localization_1 = require("@skype/bew-localization");
const config_1 = require("config");
const React = require("react");
const ClipboardHelper_1 = require("../../helpers/ClipboardHelper");
const removeProtocol = (url) => url.replace('https://', '');
class JoinLink extends React.Component {
    constructor(props) {
        super(props);
        this._getClickHandler = (joinLink) => () => {
            ClipboardHelper_1.clipboardHelper.copyToClipboard(joinLink);
            this.setState({
                copied: true,
            });
        };
        this._getKeyDownHandler = (joinLink) => (e) => {
            if (13 !== e.keyCode) {
                return;
            }
            this._getClickHandler(joinLink)();
        };
        this.state = {
            copied: false,
        };
    }
    componentDidUpdate() {
        if (!this.state.copied) {
            return;
        }
        setTimeout(() => this.setState({
            copied: false,
        }), 5000);
    }
    render() {
        const copied = this.state.copied;
        const joinLink = `${config_1.default.urls.app.join}/${this.props.shortId}`;
        const joinLinkClassName = `joinLink ${copied ? 'copied' : ''}`;
        return (React.createElement("div", { className: 'joinLinkContainer' },
            bew_localization_1.localizer.getString('txt_launch_universal_link_fallback'),
            React.createElement("div", { role: 'button', tabIndex: 0, className: joinLinkClassName, onClick: this._getClickHandler(joinLink), onKeyDown: this._getKeyDownHandler(joinLink) }, removeProtocol(joinLink)),
            copied && React.createElement("div", { className: 'info' }, bew_localization_1.localizer.getString('txt_launch_link_copied'))));
    }
}
exports.JoinLink = JoinLink;
